module.exports = __webpack_public_path__ + "img/wxsphsq.3caeba58.png";